export const sortTable = (sortColumn, data, sortBy) => {
  if (data.length === 1) {
    return data;
  }

  if (sortColumn === '') {
    return data;
  }

  const sorted = data.sort((a, b) => {
    // this will make the null or undefined values come at the last of the list for both types of sorting
    if ([undefined, null].includes(a[sortColumn])) {
      return 1;
    }
    if ([undefined, null].includes(b[sortColumn])) {
      return -1;
    }
    if (sortBy === 'desc') {
      if (b[sortColumn] > a[sortColumn]) {
        return 1;
      }
      return b[sortColumn] < a[sortColumn] ? -1 : 0;
    }
    if (b[sortColumn] < a[sortColumn]) {
      return 1;
    }
    return b[sortColumn] > a[sortColumn] ? -1 : 0;
  });
  return sorted;
};

export default {
  sortTable
};
